<mat-form-field appearance="standard" class="selector" *ngIf="actions?.length">
  <mat-select panelClass="skip-first" [(ngModel)]="selectedAction" (ngModelChange)="onAction($event)">
    <mat-option value="">Actions</mat-option>
    <mat-option *ngFor="let action of actions" [value]="action.value" [disabled]="action.disabled">
      {{ action.text }}
    </mat-option>
  </mat-select>
</mat-form-field>
